import { CloseButton, keyframes } from '@chakra-ui/react';
import { Alert, AlertDescription, AlertIcon, Button } from '@/components/v4';

// A steady brand ring, with a second one spreading out from it and fading
const ringPulse = keyframes`
  0% { box-shadow: 0 0 0 2px var(--chakra-colors-messenger-500), 0 0 0 2px var(--chakra-colors-messenger-500); }
  70%, 100% { box-shadow: 0 0 0 2px var(--chakra-colors-messenger-500), 0 0 0 8px transparent; }
`;

/**
 * While the tip shows, the Number column's filter button is ringed, so the
 * tip and the place it points to read together. Applied to the table around
 * the grid (the column defs can't change without resetting their filters).
 */
export const NUMBER_FILTER_RING_SX = {
    '.ag-header-cell[col-id="number"] .ag-header-cell-filter-button': {
        borderRadius: 'md',
        animation: `${ringPulse} 1.8s ease-out infinite`,
    },
};

/**
 * Points people to the Number column's filter for number patterns (it took
 * over from the RegEx button). Its close button hides it for good; the small
 * help line shows instead.
 */
const NumberFilterTip = ({ onOpenFilter, onDismiss }) => (
    <Alert status="info" variant="inline-accent" mt={3} pr={10}>
        <AlertIcon />
        <AlertDescription fontSize="sm">
            Filter by number pattern (starts with, ends with, length or custom
            regex) from the Number column&apos;s filter, or select specific
            numbers with Paste List.{' '}
            <Button
                variant="link"
                size="sm"
                verticalAlign="baseline"
                onClick={onOpenFilter}>
                Open number filter
            </Button>
        </AlertDescription>
        <CloseButton
            aria-label="Dismiss tip"
            size="sm"
            position="absolute"
            right={2}
            top={2}
            onClick={onDismiss}
        />
    </Alert>
);

export default NumberFilterTip;
